"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingRecurringSeriesSchema () {
        return MeetingRecurringSeriesSchema;
    },
    get MeetingRecurringSeriesStatusSchema () {
        return MeetingRecurringSeriesStatusSchema;
    },
    get RecurrenceDayOfWeekSchema () {
        return RecurrenceDayOfWeekSchema;
    },
    get RecurrenceFrequencySchema () {
        return RecurrenceFrequencySchema;
    },
    get RecurrenceSchema () {
        return RecurrenceSchema;
    },
    get RecurrenceWeekOfMonthSchema () {
        return RecurrenceWeekOfMonthSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _videoconference = require("../video-conference");
const MeetingRecurringSeriesStatusSchema = _zod.z.enum([
    "active",
    "finished",
    "deleted"
]).default("active");
const RecurrenceFrequencySchema = _zod.z.enum([
    "weekly",
    "monthly"
]);
const RecurrenceDayOfWeekSchema = _zod.z.enum([
    "MO",
    "TU",
    "WE",
    "TH",
    "FR",
    "SA",
    "SU"
]);
const RecurrenceWeekOfMonthSchema = _zod.z.enum([
    "first",
    "second",
    "third",
    "fourth",
    "last"
]);
const RecurrenceSchema = _zod.z.object({
    frequency: RecurrenceFrequencySchema,
    /** 1 = every period; weekly + 2 = biweekly. */ interval: _zod.z.number().int().min(1).max(4),
    day_of_week: RecurrenceDayOfWeekSchema,
    /** Monthly only — e.g. "second" + TU = the second Tuesday of each month. */ week_of_month: RecurrenceWeekOfMonthSchema.optional()
});
const MeetingRecurringSeriesSchema = _base.BaseDocument.extend({
    /** Foreign key - meeting_workspaces document */ meeting_workspace_id: _zod.z.instanceof(_bson.ObjectId),
    // Template applied to every materialized meeting
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: MeetingRecurringSeriesStatusSchema,
    recurrence: RecurrenceSchema,
    // Series anchor. Meetings store plain UTC instants, so the series carries its own
    // wall-clock time + IANA timezone; occurrence math runs in this zone (DST-safe).
    timezone: _zod.z.string(),
    /** Wall-clock start in the anchor timezone, "HH:mm". */ start_time_of_day: _zod.z.string(),
    duration_minutes: _zod.z.number().int().positive(),
    series_start_date: _zod.z.instanceof(Date),
    /** Absent = the series never ends. */ series_end_date: _zod.z.instanceof(Date).optional(),
    /** Series-level always/never carryover of unchecked items into each new meeting. */ carry_over: _zod.z.boolean(),
    /**
	 * The single identity whose calendar/video-conferencing tokens the series uses
	 * (the series creator in v1). Materialization runs as this user.
	 */ integration_owner_id: _zod.z.instanceof(_bson.ObjectId),
    add_to_calendar: _zod.z.boolean(),
    /** The native recurring event on the owner's calendar, when one was created. */ calendar_series: _zod.z.object({
        provider: _zod.z.enum([
            "google",
            "outlook"
        ]),
        calendar_id: _zod.z.string(),
        master_event_id: _zod.z.string()
    }).optional(),
    video_conferencing_provider: _zod.z.enum(_videoconference.VIDEO_CONFERENCING_PROVIDERS).optional(),
    // Materialization pointers
    current_meeting_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    /** Start of the NEXT (unmaterialized) occurrence. */ next_occurrence_at: _zod.z.instanceof(Date),
    /** Current meeting's end + 2h; re-stamped when the current meeting is rescheduled. */ next_materialization_at: _zod.z.instanceof(Date),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord,
    /** Soft delete record. */ deleted: _useractionrecord.UserActionRecord.optional()
});
